import { render, staticRenderFns } from "./TxTable.vue?vue&type=template&id=75ae3d8e&scoped=true"
import script from "./TxTable.vue?vue&type=script&lang=js"
export * from "./TxTable.vue?vue&type=script&lang=js"
import style0 from "./TxTable.vue?vue&type=style&index=0&id=75ae3d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ae3d8e",
  null
  
)

export default component.exports